import { SocketStock } from '@/helpers/models/stock/socket_stock.model';
import { GeneralStockModel } from '../models/generalstock.model';
import { StockMarkets } from '../models/stocks.model';
import httpService from '@/services/http.service';
import { ref } from "vue";


let allStocks = ref<GeneralStockModel[]>([]);
let topTenStocks = ref<any[]>([]);
let topTenCrypto = ref<GeneralStockModel[]>([]);

export const useStocks = () => {
    let stocks = ref<GeneralStockModel[]>([]);

    const getstocks = async (keyword: string | undefined = undefined, isFirst: boolean = false) => {
        if (keyword && keyword.length) {
            stocks.value = [];
        }
        return httpService.searchStockCrypto(keyword).then((response) => {
            if (response.data.isSuccess && response.data.data.length) {
                for (let obj of response.data.data) {
                    var stock = new GeneralStockModel();
                    stock = GeneralStockModel.copy(stock, obj);
                    let index = allStocks.value.findIndex(x => x._id == stock._id && x.symbol == stock.symbol && x.type == stock.type);
                    if (index == -1) {
                        allStocks.value.push(stock);
                    } else {
                        GeneralStockModel.copy(allStocks.value[index], stock);
                    }
                    let stockInd = stocks.value.findIndex(x => x._id == stock._id && x.symbol == stock.symbol && x.type == stock.type);
                    if (stockInd == -1) {
                        stocks.value.push(stock);
                    } else {
                        GeneralStockModel.copy(stocks.value[stockInd], stock);
                    }
                }
                if (!keyword || !keyword.length) {
                    stocks.value = [];
                    stocks.value = JSON.parse(JSON.stringify(allStocks.value));
                }
                return true
            } else {
                return false
            }

        }).catch((err) => {
            return false
        });
    }
    const findTopTens = () => {
        for (let stock of allStocks.value) {
            if (stock.type == StockMarkets.crypto && topTenCrypto.value.length < 10) {
                topTenCrypto.value.push(stock);
            }
        }
    };

    const compareArrays = (updatedArr: GeneralStockModel[], existingArray: GeneralStockModel[]) => {
        var stocksToRemove: GeneralStockModel[] = [];
        var stocksToAdd: GeneralStockModel[] = [];
        for (let addSt of existingArray) {
            if (updatedArr.findIndex((x) => x.symbol == addSt.symbol) == -1) {
                stocksToRemove.push(addSt);
            }
        }
        for (let remSt of updatedArr) {
            if (
                existingArray.findIndex((x: any) => x.symbol == remSt.symbol) == -1
            ) {
                stocksToAdd.push(remSt);
            }
        }
        return {
            stocksToAdd,
            stocksToRemove,
        }
    };

    const getTopTenStock = () => {
        return new Promise<GeneralStockModel[]>((resolve, reject) => {
            httpService.getTopNasdaqStocks().then((res) => {
                if (res.data.isSuccess) {
                    let symbolsArray = res.data.data
                    topTenStocks.value = symbolsArray.map((item: SocketStock) => {
                        return {
                            _id: item.stockId,
                            companyName: item.name,
                            ticker: item.symbol,
                            symbol: item.symbol,
                            price: item.price,
                            change: item.change,
                            changePercent: SocketStock.getChangesPercentage(item.price, item.previousClose),
                            logoUrl: item.logoUrl,
                            exchange: item.exchange,
                            type: item.type,
                            marketCap: item.marketCap,
                        };
                    })
                    resolve(topTenStocks.value);
                }
            }).catch((e) => {
                resolve([]);

            })
        });
    }

    const getTopTenCrypto = () => {
        return new Promise<GeneralStockModel[]>((resolve, reject) => {
            httpService.getTopCrypto().then((res) => {
                if (res.data.isSuccess) {
                    let symbolsArray = res.data.data.filter((x: any) => x);
                    topTenCrypto.value = symbolsArray.map((item: SocketStock) => {
                        return {
                            _id: item.stockId,
                            companyName: item.name,
                            ticker: item.symbol,
                            symbol: item.symbol,
                            price: item.price,
                            change: item.change,
                            changePercent: item.changesPercentage,
                            logoUrl: item.logoUrl,
                            exchange: item.exchange,
                            type: item.type,
                            marketCap: item.marketCap,
                        };
                    })
                    resolve(topTenCrypto.value);
                }
            }).catch((e) => {
                resolve([]);

            })
        });
    }


    return {
        stocks,
        topTenStocks,
        topTenCrypto,
        compareArrays,
        getstocks,
        getTopTenStock,
        getTopTenCrypto,
    }

}